import { styled } from '../../../base';

export const StyledHistoryContainer = styled('div')(({ theme }) => ({
    padding: theme.spacing(2),
    paddingInlineEnd: theme.spacing(7),
    background: theme.palette.background.paper,
}));
